import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { api } from '@/lib/api'
import { AimeLogo } from '@/components/AimeLogo'

export default function ForgotPasswordPage() {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await api('/api/auth/request-password-reset', {
        method: 'POST',
        body: JSON.stringify({
          email,
          redirectTo: new URL('/reset-password', window.location.origin).href,
        }),
      })
      setSent(true)
    } catch {
      setError(t('auth.resetSendError'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center p-6">
      <div className="w-full max-w-sm space-y-6">
        <div className="flex flex-col items-center gap-3 text-center">
          <AimeLogo size={120} />
          <h1 className="sr-only">Aime — {t('auth.forgotPasswordTitle')}</h1>
          <p className="text-on-surface-variant mt-1">{t('auth.forgotPasswordTitle')}</p>
        </div>

        {sent ? (
          <div className="space-y-4">
            <p className="text-on-surface-variant text-center text-sm">{t('auth.resetLinkSent')}</p>
            <Link
              to="/sign-in"
              className="bg-primary text-primary-foreground hover:bg-primary/90 inline-flex h-10 w-full items-center justify-center rounded-xl px-4 py-2 text-sm font-medium"
            >
              {t('auth.backToSignIn')}
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <p className="text-on-surface-variant text-sm">{t('auth.forgotPasswordDescription')}</p>
            <div>
              <label className="text-sm font-medium" htmlFor="email">
                {t('auth.email')}
              </label>
              <input
                id="email"
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="border-outline-variant/30 bg-surface-container ring-offset-background focus-visible:ring-ring mt-1 flex h-10 w-full rounded-xl border px-3 py-2 text-sm focus-visible:ring-2 focus-visible:outline-none"
              />
            </div>

            {error && <p className="text-destructive text-sm">{error}</p>}

            <button
              type="submit"
              disabled={loading}
              className="bg-primary text-primary-foreground hover:bg-primary/90 inline-flex h-10 w-full items-center justify-center rounded-xl px-4 py-2 text-sm font-medium disabled:opacity-50"
            >
              {loading ? '...' : t('auth.sendResetLink')}
            </button>

            <p className="text-on-surface-variant text-center text-sm">
              <Link to="/sign-in" className="text-primary hover:underline">
                {t('auth.backToSignIn')}
              </Link>
            </p>
          </form>
        )}
      </div>
    </div>
  )
}
